module.exports = __webpack_public_path__ + "static/media/not-found-vader.7182b41b.gif";